
import {Component, Prop, Vue, Watch, Ref} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {ingresoStore} from "@/store/ingresoStore";
import * as stream from "stream";
import router from "@/router";

@Component({
  name: "materialNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  @Ref('fileInput') fileInput!: HTMLInputElement;
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  material = {
    codigo: '',
    descripcion: '',
    partida: '',
    unidad: '',
    fecha_creacion: DateTime.now().toFormat('yyyy-MM-dd'),
    numero: '',
    partida_id:  '',
    grupo_id: '',
    imagen: ''
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;
  image = '';
  imagenMaterial = null
  //@Ref('fileInput') fileInput!: HTMLInputElement;

  private imageBase64: string | null = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted() {
    this.getGrupoMaterial();
    this.getPartidaGasto();
    this.getUnidad();
  }


  get unidad(): any {
    return this.materialStore.unidad;
  }

  getUnidad() {
    this.materialService.getUnidad();
  }


  get loading(): boolean {
    return this.materialStore.loading;
  }


  get grupoMaterial(): any {
    return this.materialStore.grupoMaterial;
  }

  getGrupoMaterial() {
    this.materialService.getGrupoMaterial();
  }

  get partidaGasto(): any {
    return this.materialStore.partidaGasto;
  }

  get nuevoMaterial(): any[] {
    return this.materialStore.newMaterial;
  }
  getPartidaGasto() {
    this.materialService.getPartidaGasto();
  }

  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar el Nuevo Material: <br>
                    ${this.material.descripcion}`
    ).then(res => {
      const data = {material:this.material}
      if (res.isConfirmed) {
        if (this.nuevoMaterial.length !== 0){
          const data = {materialId:this.nuevoMaterial.id, material:this.material}
          this.materialService.updateMaterial(data);
        }
        else {
          const data = {material:this.material}
          this.materialService.saveMaterial(data);
        }
        //router.push({name: 'materiales'});
        //this.$emit('listar')
      }
    })
  }

  private handleFileChange(): void {
    const files = this.fileInput.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageBase64 = reader.result as string;
      };
      reader.readAsDataURL(files[0]);
    }
  }


  private uploadImage(): void {
    if (!this.imageBase64) {
      alert('Por favor selecciona una imagen.');
      return;
    }

    const data = {image: this.imageBase64, id: this.nuevoMaterial.id}

    this.materialService.adjuntarImagen(data);
  }




}
